import React from "react";
import RecheckStaffWindow from "../../Global/RecheckStaffWindow";

const StaffRecheck = () => {
  return <RecheckStaffWindow />;
};

export default StaffRecheck;
